import * as types from "./actions";
import APIUtil from "../config/APIUtil";
import UrlConstants from "../config/UrlConstants";
import * as code from "../config/Constants";
import { cryptoTokenDecode } from "../components/Common/Common";

/**
 *
 * @desc Create New Campaign data API call
 */
export function createCampaignAction(data) {
  let userType = cryptoTokenDecode().usertype;
  if (userType === "VENDOR") {
    data.ownerId = localStorage.getItem("ownerId");
  }
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.pathwaybuyerAgentMasterTemplate + "?model=campaign",
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.BUYER_CREATE_MASTER_TEMPLATE,
          newCampaign: response.data,
        });
      } else {
        dispatch({
          type: types.BUYER_CREATE_MASTER_TEMPLATE,
          newCampaign: {},
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc Update master template data API call
 */
export function createTaskAction(data) {
  let userType = cryptoTokenDecode().usertype;
  let url;
  if (userType === "VENDOR") {
    data.ownerId = localStorage.getItem("ownerId");
  }
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.pathwaybuyerAgentMasterTemplate,
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.BUYER_CREATE_TASK,
          isEventCommCreated: true,
          addedEventComm: response.data,
        });
      } else {
        dispatch({
          type: types.BUYER_CREATE_TASK,
          isEventCommCreated: false,
          addedEventComm: [],
        });
      }

      return response.data;
    });
  };
}

/**
 *
 * @desc Delete Communication template
 */
export function deleteTaskAction(eventtemplateId) {
  return function(dispatch) {
    var url =
      UrlConstants.pathwaybuyerAgentMasterTemplate + "?id=" + eventtemplateId;
    return APIUtil.deleteMethod(url, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.BUYER_DELETE_TASK,
          isMasterTemplateTaskDeleted: true,
        });
      } else {
        dispatch({
          type: types.BUYER_DELETE_TASK,
          isMasterTemplateTaskDeleted: false,
        });
      }
    });
  };
}

/**
 *
 * @desc List Buyer Agents Matser template API call
 */
export function getBuyerAgentMasterTemplateAction(id) {
  let userType = cryptoTokenDecode().usertype;
  // console.log("userType13", userType);
  let url;
  if (userType === "VENDOR") {
    let ownerId = localStorage.getItem("ownerId");
    url =
      UrlConstants.pathwaybuyerAgentMasterTemplate + "?" + "ownerId=" + ownerId;
  } else {
    url = UrlConstants.pathwaybuyerAgentMasterTemplate + (id || "");
  }
  return function(dispatch) {
    return APIUtil.getMethod(url, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.BUYER_GET_MASTER_TEMPLATE_DATA,
          buyerMasterTemplates: response.data.data,
          totalBuyerTemplates: response.data.total,
        });
      } else {
        dispatch({
          type: types.BUYER_GET_MASTER_TEMPLATE_DATA,
          buyerMasterTemplates: {},
          totalBuyerTemplates: 0,
        });
      }
    });
  };
}

/**
 *
 * @desc Get list of variables
 */
export function getTasksByCampaignIdAction(id) {
  let userType = cryptoTokenDecode().usertype;
  // console.log("userType14", userType);
  let url;
  if (userType === "VENDOR") {
    let ownerId = localStorage.getItem("ownerId");
    url =
      UrlConstants.pathwaybuyerAgentMasterTemplate +
      "?campaign=" +
      id +
      "&ownerId=" +
      ownerId;
  } else {
    url = UrlConstants.pathwaybuyerAgentMasterTemplate + "?campaign=" + id;
  }
  return function(dispatch) {
    return APIUtil.getMethod(url, true).then(
      (response) => {
        if (response.status === code.OK) {
          dispatch({
            type: types.MASTER_TEMPLATE_GET_CAMPAIGN_DATA_BY_ID_BUYER,
            BuyerCampDataById: response.data.data,
          });
        } else {
          dispatch({
            type: types.MASTER_TEMPLATE_GET_CAMPAIGN_DATA_BY_ID_BUYER,
            BuyerCampDataById: [],
          });
        }
        return response.data;
      },
      (error) => {
        return error;
      }
    );
  };
}

/**
 *
 * @desc Update dependent Task
 */
export function updateDependentTaskAction(
  data,
  model,
  campaignId,
  eventTempId,
  commuId,
  type
) {
  return function(dispatch) {
    return APIUtil.putMethod(
      UrlConstants.pathwayupdateBuyerDependentTaskURL + eventTempId,
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.BUYER_UPDATE_DEPENDENT_TASKS,
        });
        return response.data;
      } else {
        dispatch({
          type: types.BUYER_UPDATE_DEPENDENT_TASKS,
        });
        return response;
      }
    });
  };
}

/**
 *
 * @desc Update master template data API call
 */
export function updateTaskAction(
  data,
  model,
  campaignId,
  eventTempId,
  commuId,
  type
) {
  return function(dispatch) {
    return APIUtil.putMethod(
      UrlConstants.pathwaybuyerAgentMasterTemplate +
        "?id=" +
        eventTempId +
        model,
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.BUYER_UPDATE_MASTER_TEMPLATE_DATA,
          isMasterTemplateUpdatedBuyer: true,
          updatedEventDataBuyer: response.data,
        });
        return response.data;
      } else {
        dispatch({
          type: types.BUYER_UPDATE_MASTER_TEMPLATE_DATA,
          isMasterTemplateUpdatedBuyer: false,
          updatedEventDataBuyer: [],
        });
        return response.data;
      }
    });
  };
}

/**
 *
 * @desc Delete compaign from list
 */
export function deleteUserCampaignListAction(data) {
  let url = UrlConstants.pathwaydeleteUserCampaignUrl + "/" + data.id;

  return function(dispatch) {
    return APIUtil.putMethod(url, data, true).then((response) => {
      dispatch({
        type: types.BUYER_GET_MASTER_TEMPLATE_DATA,
        buyerMasterTemplates:
          response.status === code.OK ? response.data.data : {},
        totalBuyerTemplates:
          response.status === code.OK ? response.data.total : 0,
      });
      return response;
    });
  };
}

/**
 *
 * @desc Add pathway to Transaction
 */
export function addPathwayToTransactionAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.addPathwayToTransactionUrl,
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.ADD_PATHWAY_TO_TRANSACTION,
          addedPathway: response.data,
        });
      } else {
        dispatch({
          type: types.ADD_PATHWAY_TO_TRANSACTION,
          addedPathway: [],
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc Get list of pathways
 */
export function getTransactionPathwaysListAction(transactionId) {
  let url = UrlConstants.getTransactionPathwaysListUrl + "/" + transactionId;

  return function(dispatch) {
    return APIUtil.getMethod(url, true).then(
      (response) => {
        // console.log("getTransactionPathwaysListAction response ", response);
        if (response.status === code.OK) {
          // console.log(
          //   "getTransactionPathwaysListAction response OK ",
          //   response
          // );
          dispatch({
            type: types.TRANSACTION_PATHWAYS_LIST,
            transactionPathwaysData: response.data,
          });
        } else {
          dispatch({
            type: types.TRANSACTION_PATHWAYS_LIST,
            transactionPathwaysData: [],
          });
        }
        return response.data;
      },
      (error) => {
        return error;
      }
    );
  };
}

/**
 *
 * @desc Permanant delete transaction pathway
 */
export function removeTransactionPathwayAction(data) {
  return function(dispatch) {
    let url = UrlConstants.deleteTransactionPathway;
    return APIUtil.deleteMethod(url, true, data).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.REMOVE_TRANSACTION_PATHWAY,
          status: true,
          UserMessage: "Transaction pathway has been removed.",
        });
      } else {
        dispatch({
          type: types.REMOVE_TRANSACTION_PATHWAY,
          status: false,
          UserMessage: "Something went wrong. Please try again!",
        });
      }
      return response;
    });
  };
}


/**
 *
 * @desc get user pathways for default listing
 */
export function getUserPathwaysAction(id) {
  let url;
  if(id){
    url = UrlConstants.pathwaybuyerAgentMasterTemplate + "/userpathway?id=" + id;
  }
  else{
    url = UrlConstants.pathwaybuyerAgentMasterTemplate + "/userpathway";
  }
  return function(dispatch) {
    return APIUtil.getMethod(url,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.BUYER_GET_MASTER_TEMPLATE_DATA,
          buyerMasterTemplates: response.data.data,
        });
      } else {
        dispatch({
          type: types.BUYER_GET_MASTER_TEMPLATE_DATA,
          buyerMasterTemplates: {},
        });
      }
      return response;
    });
  };
}


/**
 *
 * @desc update default user pathway
 */
export function updateUserPathwayDefaultAction(data) {
  let url = UrlConstants.pathwaybuyerAgentMasterTemplate + "/userdefaultpathway";

  return function(dispatch) {
    return APIUtil.putMethod(url, data, true).then((response) => {
      dispatch({
        type: types.BUYER_GET_MASTER_TEMPLATE_DATA,
        buyerMasterTemplates:
          response.status === code.OK ? response.data.data : {},
      });
      return response;
    });
  };
}

//*********************************** Admin ********************************************************** */
//admin pathway master template apis

/**
 *
 * @desc Admin : Copy campaign
 */
export function adminCopyCampaignMaterTemplateAction(data) {
  let userType = cryptoTokenDecode().usertype;
  if (userType === "VENDOR") {
    data.ownerId = localStorage.getItem("ownerId");
  }
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.pathwayAdminCopyCampaignMaterTemplateUrl,
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.COPY_CAMPAIGN_MASTER_TEMPLATE,
          isCampaignCreated: true,
          addedCampaign: response.data,
        });
      } else {
        dispatch({
          type: types.COPY_CAMPAIGN_MASTER_TEMPLATE,
          isCampaignCreated: false,
          addedCampaign: [],
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc Api call for get admin matser teamplates
 */
export function adminGetMaterTemplateAction() {
  return function(dispatch) {
    return APIUtil.getMethod(
      UrlConstants.pathwayAdminGetMaterTemplateUrl,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.ADMIN_GET_MASTER_TEMPLATE_DATA,
          adminMasterTemplates: response.data.data,
          totalAdminTemplates: response.data.total,
        });
      } else {
        dispatch({
          type: types.ADMIN_GET_MASTER_TEMPLATE_DATA,
          adminMasterTemplates: {},
          totalAdminTemplates: 0,
        });
      }
    });
  };
}

/**
 *
 * @desc Get campaign data by campaign id - api call
 */
export function adminGetCampDataByIdAction(id) {
  let url = UrlConstants.pathwayAdminGetCampDataByIdMaterTemplateUrl;
  url = url.replace("{campId}", id);
  return function(dispatch) {
    return APIUtil.getMethod(url, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.MASTER_TEMPLATE_GET_CAMPAIGN_DATA_BY_ID,
          campDataById: response.data.data,
        });
      } else {
        dispatch({
          type: types.MASTER_TEMPLATE_GET_CAMPAIGN_DATA_BY_ID,
          campDataById: [],
        });
      }
    });
  };
}

/**
 *
 * @desc Admin : Create campaign
 */
export function adminCreatCampaignMaterTemplateAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.pathwayAdminCreatCampaignMaterTemplateUrl,
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.CREATE_CAMPAIGN_MASTER_TEMPLATE,
          isCampaignCreated: true,
          addedCampaign: response.data,
        });
      } else {
        dispatch({
          type: types.CREATE_CAMPAIGN_MASTER_TEMPLATE,
          isCampaignCreated: false,
          addedCampaign: [],
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc Update master template data API call
 */
export function adminCreatEventCommMaterTemplateAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.pathwayAdminCreatEventCommMaterTemplateUrl,
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.CREATE_EVENT_COMM_MASTER_TEMPLATE,
          isEventCommCreated: true,
          addedEventComm: response.data,
        });
      } else {
        dispatch({
          type: types.CREATE_EVENT_COMM_MASTER_TEMPLATE,
          isEventCommCreated: false,
          addedEventComm: [],
        });
      }
    });
  };
}

/**
 *
 * @desc Delete Communication template
 */
export function adminDelEventCommunicationAction(eventtemplateId) {
  return function(dispatch) {
    var url = UrlConstants.pathwayAdminDeleteEventCommMaterTemplateUrl.replace(
      "{eventtemplateId}",
      eventtemplateId
    );
    return APIUtil.deleteMethod(url, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.DELETE_EVENT_COMM_MASTER_TEMPLATE,
          isMasterTemplateTaskDeleted: true,
        });
      } else {
        dispatch({
          type: types.DELETE_EVENT_COMM_MASTER_TEMPLATE,
          isMasterTemplateTaskDeleted: false,
        });
      }
    });
  };
}

/**
 *
 * @desc Update Dependant tasks after confirmation
 */
export function adminUpdateDependentTasksAction(
  data,
  model,
  campaignId,
  eventTempId,
  commuId,
  type
) {
  return function(dispatch) {
    return APIUtil.putMethod(
      UrlConstants.pathwayUploadDependentTaskURL + eventTempId,
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.UPDATE_DEPENDENT_TASKS,
        });
        return response.data;
      } else {
        dispatch({
          type: types.UPDATE_DEPENDENT_TASKS,
        });
        return response;
      }
    });
  };
}

/**
 *
 * @desc Update master template data API call
 */
export function adminUpdateMaterTemplateAction(
  data,
  model,
  campaignId,
  eventTempId,
  commuId,
  type
) {
  var url = UrlConstants.AdminUpdateBothMaterTemplateUrl;
  if (model === "campaign") {
    url = UrlConstants.pathwayAdminUpdateCampMaterTemplateUrl.replace(
      "{model}",
      model
    );
    url = url.replace("{campaignId}", campaignId);
  }

  if (model === "both") {
    url = UrlConstants.pathwayAdminUpdateBothMaterTemplateUrl.replace(
      "{eventTempId}",
      eventTempId
    );
    if (type === 0) {
      url = url.replace("{commuId}", commuId);
    } else {
      //remove commuid from url
      url = url.replace("&communicationtemplateId={commuId}", "");
    }
  }

  return function(dispatch) {
    return APIUtil.putMethod(url, data, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.ADMIN_UPDATE_MASTER_TEMPLATE_DATA,
          isMasterTemplateUpdated: true,
          updatedEventData: response.data,
        });
        return response.data;
      } else {
        dispatch({
          type: types.ADMIN_UPDATE_MASTER_TEMPLATE_DATA,
          isMasterTemplateUpdated: false,
          updatedEventData: [],
        });
        return response.data;
      }
    });
  };
}

export function deleteSystemCampaignListAction(data) {
  let url = UrlConstants.pathwayAdminDeleteSystemCampaignUrl + "/" + data.id;

  return function(dispatch) {
    return APIUtil.putMethod(url, data, true).then((response) => {
      dispatch({
        type: types.ADMIN_GET_MASTER_TEMPLATE_DATA,
        adminMasterTemplates:
          response.status === code.OK ? response.data.data : {},
        totalAdminTemplates:
          response.status === code.OK ? response.data.total : 0,
      });
      return response;
    });
  };
}

/**
 *
 * @desc API call to get dependency task
 */
export function GetDependencytasksAction(campaign, day, event, module) {
  // console.log("pathway dependency call===>")
  let url = "";
  return function(dispatch) {
    if (module == "ADMIN") {
      url = `${
        UrlConstants.pathwaySetDependency
      }campaign=${campaign}&day=${day}&eventId=${event}&isTransaction=false`;
    }
    if (module == "USER") {
      url = `${
        UrlConstants.pathwaySetDependency
      }campaign=${campaign}&day=${day}&eventId=${event}`;
    }
    if (module == "TRANSACTION") {
      url = `${
        UrlConstants.pathwaySetDependency
      }day=${day}&transactionId=${campaign}&eventId=${event}`;
    }
    return APIUtil.getMethod(url, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.GET_DEPENDENCY_DATA,
          dependencyTasks: response.data,
        });
      } else {
        dispatch({
          type: types.GET_DEPENDENCY_DATA,
          dependencyTasks: {},
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc API call for update dependent tasks
 */
export function putDependencytasksAction(event, module, apidata) {
  let url = "";
  return function(dispatch) {
    if (module == "ADMIN") {
      url = `${
        UrlConstants.pathwaySetDependency
      }eventId=${event}&isTransaction=false`;
    }
    if (module == "BUYERAGENT") {
      url = `${UrlConstants.pathwaySetDependency}eventId=${event}`;
    }
    if (module == "ACCTOWNER") {
      url = `${UrlConstants.pathwaySetDependency}eventId=${event}`;
    }
    if (module == "TRANSACTION") {
      url = `${
        UrlConstants.pathwaySetDependency
      }eventId=${event}&isTransaction=true`;
    }
    return APIUtil.putMethod(url, apidata, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.PUT_DEPENDENCY_DATA,
          dependencyTasks: response,
          status: true,
          statusMessage: "Dependencies Added Successfully",
        });
      } else {
        dispatch({
          type: types.PUT_DEPENDENCY_DATA,
          dependencyTasks: {},
          status: false,
          statusMessage: "Something went Wrong",
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc List dependency Tasks API call
 */
export function deleteDependencytasksAction(event, module, apidata) {
  let url = "";
  return function(dispatch) {
    if (module == "ADMIN") {
      url = `${
        UrlConstants.pathwaySetDependency
      }id=${event}&isTransaction=false&removeId=${apidata}`;
    }
    if (module == "BUYERAGENT") {
      url = `${
        UrlConstants.pathwaySetDependency
      }id=${event}&removeId=${apidata}`;
    }
    if (module == "ACCTOWNER") {
      url = `${
        UrlConstants.pathwaySetDependency
      }id=${event}&removeId=${apidata}`;
    }
    if (module == "TRANSACTION") {
      url = `${
        UrlConstants.pathwaySetDependency
      }id=${event}&isTransaction=true&removeId=${apidata}`;
    }
    return APIUtil.deleteMethod(url, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.PUT_DEPENDENCY_DATA,
          dependencyTasks: response,
          status: true,
          statusMessage: "Dependencies Removed Successfully",
        });
      } else {
        dispatch({
          type: types.PUT_DEPENDENCY_DATA,
          dependencyTasks: {},
          status: false,
          statusMessage: "Something went Wrong",
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc update Pathway Anchor Action
 */
export function updatePathwayAnchorAction(data) {
  return function(dispatch) {
    return APIUtil.putMethod(
      UrlConstants.pathwaybuyerAgentMasterTemplate + "/update-anchor",
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.BUYER_CREATE_MASTER_TEMPLATE,
          updatedPathwayCampaign: response.data,
        });
        return response.data;
      } else {
        dispatch({
          type: types.BUYER_CREATE_MASTER_TEMPLATE,
          updatedPathwayCampaign: [],
        });
        return response.data;
      }
    });
  };
}
